import { socialTypes, embedTypes, originalBlockTypes, calendarBlockType, COLORS, ICONS } from "./constants";

import { capitalize } from "utils/capitalize";

export const emptyPageElement = {
    content: "",
    image_file: null,
    element_type: "",
    reward_ids: ["public"],
    link_title: "",
};

export const isSocialElement = (element_type) => {
  return socialTypes.some(socialType => socialType.value === element_type);
};

export const isEmbeddedElement = (element_type) => {
  if (element_type === "embed") return true;
  return embedTypes.some(embedType => embedType.value === element_type);
};

export const detectEmbedType = (url) => {
  const youtubeRegexes = [
    /https?:\/\/youtu\.be\/(.+)/,
    /https?:\/\/(?:www\.)?youtube\.com\/watch\?v=([^&]+)/,
    /https?:\/\/(?:www\.)?youtube\.com\/v\/([^#?]+)/,
    /https?:\/\/(?:www\.)?youtube\.com\/live\/([^#?]+)/,
    /https?:\/\/m\.youtube\.com\/watch\?v=([^&]+)/,
    /https?:\/\/m\.youtube\.com\/v\/([^#?]+)/,
    /https?:\/\/(?:www\.)?youtube\.com\/shorts\/([^?]+)/,
    /https?:\/\/(?:www\.)?youtube\.com\/playlist\?list=([^&]+)/
  ];

  const spotifyRegexes = [
    /https?:\/\/open\.spotify\.com\/intl-pt\/([^?]+)/,
    /https?:\/\/open\.spotify\.com\/([^?]+)/
  ];

  const soundcloudRegexes = [
    /https?:\/\/soundcloud\.com\/([^?]+)/
  ];

  if (youtubeRegexes.some(regex => regex.test(url))) return 'youtube';
  if (spotifyRegexes.some(regex => regex.test(url))) return 'spotify';
  if (soundcloudRegexes.some(regex => regex.test(url))) return 'soundcloud';
  return null;
};

export const isEmbeddedableElement = (content) => {
  return detectEmbedType(content) !== null;
};

const ELEMENT_TYPE_LABELS = {
  embedded: "Embedded Media",
  title: "Header",
};

export const getLabel = (elementType) => {
  if (isEmbeddedElement(elementType)) return ELEMENT_TYPE_LABELS.embedded;
  if (elementType === "title") return ELEMENT_TYPE_LABELS.title;

  return elementType ? capitalize(elementType) : "Link or Embedded Media";
};

export const getColor = (elementType) => {
  return COLORS[elementType] || null;
};

export const getIcon = (elementType) => {
  return ICONS[elementType] || null;
};

export const getBlockTypes = (orgHasCalendar) => {
  const blockTypes = [...originalBlockTypes];

  if (!orgHasCalendar) {
    blockTypes.push(calendarBlockType);
  }

  return blockTypes;
};

export const getEmbedPlatformLogo = (type) => {
  return embedTypes.find(embed => embed.value === type)?.logo || null;
};

export const getSocialPlatformLogo = (type) => {
  return socialTypes.find(social => social.value === type)?.logo || null;
};

export const getPlatformColor = (type) => {
  return socialTypes.find(social => social.value === type)?.color || null;
};

